import { FC, ReactNode } from "react"
import { useSelector } from "react-redux"
import { PageRoutes } from "@/constants/routes"
import { useUserRole } from "@/hooks/useUserRole"
import { RootState } from "@/store"
import { Feature, UserRole } from "@/types/user"

type Props = {
   feature: PageRoutes | Feature
   children: ReactNode
   excludedRoles?: UserRole[]
}

const WithRoleFeatureToggle: FC<Props> = ({
   feature,
   children,
   excludedRoles,
}) => {
   const allowed = useUserRole(feature)
   const role = useSelector(
      (state: RootState) => state.userReducer.role
   ) as UserRole

   if (!allowed) return null
   if (excludedRoles && excludedRoles.includes(role)) return null

   return <>{children}</>
}

export default WithRoleFeatureToggle
